import React from 'react';
import styled from 'styled-components';

import Stack from '@mui/material/Stack';

import { isFeatureEnabled } from 'ff/common/ffAppUtils';

import { useMapControls } from 'ff/debrief/hooks';

import ControlPanel from 'ff/debrief/layouts/ControlPanel';
import LayerSelector from 'ff/debrief/components/map/LayerSelector';
import MapZoomControls from 'ff/debrief/components/map/MapZoomControls';
import SnapToRouteButton from 'ff/debrief/components/map/SnapToRouteButton';
import { AeroToggleButtons } from 'ff/debrief/components/map/settings/AeroToggleButtons';
import MapModeToggle from 'ff/debrief/components/map/MapModeToggle';

const TracklogMapControls = () => {
    const { aeroLayer } = useMapControls();
    return (
        <ControlPanel>
            <ButtonColumn>
                <UpperSection>
                    <UpperItem>
                        <LayerSelector />
                        {isFeatureEnabled('debrief_3d_map') && (
                            <MapModeToggle />
                        )}
                    </UpperItem>
                </UpperSection>
                <LowerSection spacing={1}>
                    {window.currentUser && aeroLayer && <AeroToggleButtons />}
                    <SnapToRouteButton />
                    <MapZoomControls />
                </LowerSection>
            </ButtonColumn>
        </ControlPanel>
    );
};

const UpperSection = styled(Stack)`
    flex-direction: row;
    pointer-events: none;
`;

const UpperItem = styled.div`
    margin: 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    pointer-events: all;
`;

const LowerSection = styled(Stack)`
    pointer-events: none;
    & > * {
        pointer-events: all;
    }
`;

const ButtonColumn = styled.div`
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
    pointer-events: none;
`;

export default TracklogMapControls;
